import { useEffect, useRef, useState } from 'react';
import { ChartStudio } from './components/ChartStudio';
import { Guide } from './components/Guide';
import { KnowledgeLibrary } from './components/KnowledgeLibrary';
import { SiteHeader, type PageView } from './components/SiteHeader';

export default function App() {
  const [view, setView] = useState<PageView>('chart');
  const previousViewRef = useRef<PageView>(view);

  useEffect(() => {
    const titles: Record<PageView, string> = {
      chart: '易鉴｜传统术数研究工具',
      knowledge: '知识谱系｜易鉴',
      guide: '使用说明｜易鉴'
    };
    document.title = titles[view];
    if (previousViewRef.current !== view) {
      previousViewRef.current = view;
      document.querySelector<HTMLElement>('#main-content h1')?.focus();
    }
  }, [view]);

  return (
    <>
      <a className="skip-link" href="#main-content">跳到主要内容</a>
      <SiteHeader view={view} onChange={setView} />
      <main id="main-content">
        {view === 'chart' && <ChartStudio />}
        {view === 'knowledge' && <KnowledgeLibrary />}
        {view === 'guide' && <Guide />}
      </main>
      <footer className="site-footer">
        <div>
          <span className="footer-mark">易鉴</span>
          <p>排盘有结果，解释有出处。</p>
        </div>
        <p>AI 解读可能出错，只用于传统文化研究与娱乐，不要据此作医疗、法律、投资等现实决定。</p>
      </footer>
    </>
  );
}
